// @flow

import type {
  AuthState,
  RequestResetPasswordOperation,
  RequestResetPasswordOperator,
} from '../../types'

// Login Operator
import createRequestResetOperator from 'hfty-auth/src/requestResetPasswordOperator'

// Module Export Type
type RequestResetReducers = { [string]: (state: AuthState, payload: RequestResetPasswordOperation) => AuthState }

// Reducers
function cancelOperation (state: AuthState): AuthState {
  return {
    ...state,
    requestResetOperation: null,
  }
}

function addOperation (state: AuthState, payload: RequestResetPasswordOperation): AuthState {
  return {
    ...state,
    requestResetOperation: payload,
  }
}

function updateOperation (state: AuthState, payload: RequestResetPasswordOperation): AuthState {
  if (state.requestResetOperation) {
    return {
      ...state,
      requestResetOperation: {
        ...payload,
        model: {
          ...state.requestResetOperation.model,
          ...payload.model,
        },
      },
    }
  } else {
    return {
      ...state,
      requestResetOperation: payload,
    }
  }
}

export default function composeLoginReducer (): RequestResetReducers {
  const requestResetOperator: RequestResetPasswordOperator = createRequestResetOperator()

  return {
    [requestResetOperator.actionTypes.add()]: addOperation,
    [requestResetOperator.actionTypes.updateOperation()]: updateOperation,
    [requestResetOperator.actionTypes.cancelOperation()]: cancelOperation,
  }
}
